module.exports = __webpack_public_path__ + "static/media/file.da8ee00d.svg";